module.exports = __webpack_public_path__ + "static/media/tutoriales.2ae7133b.svg";